import React from 'react'
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import {ShellPremiumClubReportLine} from './ShellPremiumClubreportLine'
import './ShellPremiumClubReport.css'

export const ShellPremiumClubReport = ({reportObject}) => {

    const photoReportRemplate = (line) => {
        if(line.IsDays90Debt){
            return (
                    <span>
                    Наявність незакритої відстрочки платежу (90дн). Нарахування неможливе
                    </span>
            )
        }


        if(line.PhotoReport === 'Відхилено' || line.PhotoReport === 'Вiдсутнiй'){
            return ( <span style={{color:'#d20000'}}>Вiдсутнiй</span> )
        }
        else{
            return ( <span>{line.PhotoReport}</span>)
        }

    }

    const pdzTemplate = (line) => {
        if(line.IsPdz)
        {
            return <span style={{color:'#d20000'}}>Присутня</span>
        }
        else{
            return <span >Відсутня</span>
        }
    }
    const paymentsTemplate = (line) => {
        return ( <span> { line.Payment.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }) }  </span>)
    }

    const bonusTemplate = (line) => {
        return ( <span> { line.BonusAmount.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }) }  </span>)
    }

    const rowClassName = (line) => {
        return{
            'bonus-row': line.BonusAmount > 0,
            'custom-row': line.IsDays90Debt
        }
    }
    
    const planTotal = () => {
        let total = 0;

        for (let line of reportObject) {
            total += line.Plan;
        }

        return total.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    const factTotal = () => {
        let total = 0;

        for (let line of reportObject) {
            total += line.Fact;
        }

        return total.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    const paymentTotal = () => {
        let total = 0;

        for (let line of reportObject) {
            total += line.Payment;
        }

        return total.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    const bonusTotal = () => {
        let total = 0;

        for (let line of reportObject) {
            total += line.BonusAmount;
        }

        return total.toLocaleString('uk-UA', { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }


    const footerGroup = (
        <ColumnGroup>
            <Row>
                <Column footer="Загалом:" colSpan={0} footerStyle={{ textAlign: 'start' }} />
                <Column  />
                <Column footer={planTotal} />
                <Column footer={factTotal} />
                <Column  />
                <Column  />
                <Column  />
                <Column footer={paymentTotal} footerStyle={{ textAlign: 'end' }} />
                <Column footer={bonusTotal} footerStyle={{ textAlign: 'end' }} />
                
            </Row>
        </ColumnGroup>
    );

    const rowExpansionTemplate = (line) => {
        if(line.IsDays90Debt)
        {
            return (
                <>
                    <td>{line.Date}</td>
                    <td colSpan="8" style={{ textAlign: 'center' }}>Наявність незакритої відстрочки платежу (90дн). Нарахування неможливе</td>
                </>
            );
        }
        else{
            return (
                <tr>
                    <td>{line.Date}</td>
                    <td>{photoReportTemplate(line)}</td>
                    <td>{line.Plan}</td>
                    <td>{line.Fact}</td>
                    <td>{line.Performance}</td>
                    <td>{line.Remainder}</td>
                    <td>{pdzTemplate(line)}</td>
                    <td style={{ textAlign: 'end' }}>{paymentsTemplate(line)}</td>
                    <td style={{ textAlign: 'end' }}>{bonusTemplate(line)}</td>
                </tr>
            );
        }
    }

    return (
        <div className="card shell_premium_club">

            <div className="p-datatable p-component p-datatable-resizable p-datatable-resizable-fit p-datatable-responsive-scroll p-datatable-grouped-footer" data-scrollselectors=".p-datatable-wrapper"  data-pc-name="datatable" style={{width:'100% !important'}}>
                <div className="p-datatable-wrapper" data-pc-section="wrapper" style={{overflow:'auto'}} >
                    <table className="p-datatable-table p-datatable-resizable-table p-datatable-resizable-table-fit" role="table" style={{width:'100%'}}>
                        <thead className="p-datatable-thead" role="rowgroup" data-pc-name="datatable" data-pc-section="thead">
                            <tr role="row" data-pc-section="headerrow">
                                <th className="p-resizable-column" role="columnheader" data-p-sortable-column="false" data-p-resizable-column="true" data-pc-name="datatable" data-pc-section="headercell">Дата</th>
                                <th style={{textAlign:'center'}} className="p-resizable-column" role="columnheader" data-p-sortable-column="false" data-p-resizable-column="true" data-pc-name="datatable" data-pc-section="headercell">Фотозвіт</th>
                                <th style={{textAlign:'end'}} className="p-resizable-column" role="columnheader" data-p-sortable-column="false" data-p-resizable-column="true" data-pc-name="datatable" data-pc-section="headercell">План л.</th>
                                <th style={{textAlign:'end'}} className="p-resizable-column" role="columnheader" data-p-sortable-column="false" data-p-resizable-column="true" data-pc-name="datatable" data-pc-section="headercell">Факт л.</th>
                                <th style={{textAlign:'end'}} className="p-resizable-column" role="columnheader" data-p-sortable-column="false" data-p-resizable-column="true" data-pc-name="datatable" data-pc-section="headercell">Виконання</th>
                                <th style={{textAlign:'end'}} className="p-resizable-column" role="columnheader" data-p-sortable-column="false" data-p-resizable-column="true" data-pc-name="datatable" data-pc-section="headercell">Залишок л.</th>
                                <th style={{textAlign:'center'}} className="p-resizable-column" role="columnheader" data-p-sortable-column="false" data-p-resizable-column="true" data-pc-name="datatable" data-pc-section="headercell">ПДЗ</th>
                                <th style={{textAlign:'end'}} className="p-resizable-column" role="columnheader" data-p-sortable-column="false" data-p-resizable-column="true" data-pc-name="datatable" data-pc-section="headercell">Оплати грн</th>
                                <th style={{textAlign:'end'}} className="p-resizable-column" role="columnheader" data-p-sortable-column="false" data-p-resizable-column="true" data-pc-name="datatable" data-pc-section="headercell">Бонус грн</th>
                            </tr>
                        </thead>
                        <tbody className="p-datatable-tbody" role=" rowgroup" data-pc-section="tbody">
                            {
                                reportObject.length > 0 && reportObject.map((line, index) => <ShellPremiumClubReportLine key={index+'reportLine'}  line={line}/> )
                            }
                        </tbody>
                        <tfoot className="p-datatable-tfoot" role="rowgroup" data-pc-name="datatable" data-pc-section="tfoot">
                            <tr role="row" data-pc-name="datatable" data-pc-section="root">
                                <td role="cell" colSpan="0" data-pc-name="datatable" data-pc-section="footercell">
                                    Загалом:
                                </td>
                                <td role="cell" data-pc-name="datatable" data-pc-section="footercell"></td>
                                <td style={{textAlign:'end'}} role="cell" data-pc-name="datatable" data-pc-section="footercell">{planTotal()}</td>
                                <td style={{textAlign:'end'}} role="cell" data-pc-name="datatable" data-pc-section="footercell">{factTotal()}</td>
                                <td style={{textAlign:'end'}} role="cell" data-pc-name="datatable" data-pc-section="footercell"></td>
                                <td role="cell" data-pc-name="datatable" data-pc-section="footercell"></td>
                                <td role="cell" data-pc-name="datatable" data-pc-section="footercell"></td>
                                <td style={{textAlign:'end'}} role="cell" data-pc-name="datatable" data-pc-section="footercell">{paymentTotal()}</td>
                                <td style={{textAlign:'end'}} role="cell" data-pc-name="datatable" data-pc-section="footercell">{bonusTotal()}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            <div className='SPCLegend' style={{padding: '10px'}}>
                <div>
                    Дані, виділені червоним - невиконані умови акції в поточному місяці.
                </div>
                <p></p>
                <div>
                    Рядок, виділений зеленим - період, за який було нараховано бонуси за виконання умов акції.
                </div>
                <p></p>
                <div>
                    ПДЗ - прострочена дебіторська заборгованість.
                </div>
                <p></p>
                <div>
                    У стовпці «Бонус грн» чорним кольором позначені бонуси, які нараховані та готові до виплати. Червоним кольором позначені бонуси, які могли б бути нараховані, якщо б були виконані умови акції.
                </div>
            </div>
        </div>
    );
}